import { useEffect } from 'react'
import { useParams, useNavigate } from "react-router-dom"
import { backendRequest } from '../components/api'

const Tracking = () => {

    let { code } = useParams()
    const history = useNavigate()

    useEffect(() => {
        async function handleTracking() {
            try {
                // Check if tracking code exists and get redirect URL
                const res = await backendRequest('/tracking/click', 'POST', { code })

                if (res.type === 'success') {
                    // Only save to localStorage if tracking code is valid
                    localStorage.setItem(
                        'tracking-code',
                        JSON.stringify({
                            timestamp: Date.now(),
                            code: code,
                        })
                    )

                    // Redirect to custom URL or fallback to /earn
                    if (res.redirect_url) {
                        window.location.href = res.redirect_url
                    } else {
                        window.location.href = '/earn'
                    }
                } else {
                    // Invalid tracking code, redirect to /earn without saving
                    window.location.href = '/earn'
                }
            } catch (e) {
                // Error occurred, redirect to /earn without saving
                window.location.href = '/earn'
            }
        }

        if (code) {
            handleTracking()
        } else {
            window.location.href = '/earn'
        }
    }, [code])

    return (null)
}

export default Tracking